export default [
  ["#000000", "#3f3f3f", "#7f7f7f", "#bfbfbf", "#ffffff"],
  ["#990000", "#998300", "#2b9900", "#009957", "#005799", "#2b0099", "#990083"],
  ["#ff0000", "#ffda00", "#48ff00", "#00ff91", "#0091ff", "#4800ff", "#ff00da"],
  ["#ff6565", "#ffe965", "#91ff65", "#65ffbd", "#65bdff", "#9165ff", "#ff65e9"],
];
